module.exports = __webpack_public_path__ + "static/media/superai_text_white_sm.89905740.png";